import { Wallet as WalletIcon, RefreshCw, Info } from "lucide-react";

export default function WalletCard({ balance = 0, loading = false, onRefresh }) {
  return (
    <div className="relative rounded-3xl overflow-hidden text-white p-6 talabya-shadow-float" data-testid="wallet-balance-card"
      style={{ background: "linear-gradient(135deg, #E05A3D 0%, #C5452A 100%)" }}>
      <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-white/10"/>
      <div className="absolute -bottom-16 -left-8 w-52 h-52 rounded-full bg-white/5"/>
      <div className="relative">
        <div className="flex items-center justify-between gap-2 text-white/85 text-sm">
          <div className="flex items-center gap-2">
            <WalletIcon size={16}/> الرصيد الحالي
          </div>
          <button
            onClick={onRefresh}
            disabled={loading}
            className="px-2.5 py-1.5 rounded-lg bg-white/15 hover:bg-white/25 text-white text-xs font-bold flex items-center gap-1 disabled:opacity-60"
            data-testid="wallet-refresh">
            <RefreshCw size={12} className={loading ? "animate-spin" : ""}/> تحديث
          </button>
        </div>
        <div className="mt-2 flex items-baseline gap-2">
          <div className="text-5xl font-black" style={{fontFamily:"Cairo"}} data-testid="wallet-balance-value">
            {(balance || 0).toFixed(2)}
          </div>
          <div className="text-lg text-white/90">د.ل</div>
        </div>
        <div className="mt-4 flex items-start gap-2 bg-white/15 rounded-lg p-3 text-xs">
          <Info size={13} className="mt-0.5 shrink-0"/>
          <span>ادفع مباشرة برصيد محفظتك عند تأكيد الطلب. اشحن محفظتك عبر كرت الشحن أو تواصل مع الإدارة.</span>
        </div>
      </div>
    </div>
  );
}
